var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',{attrs:{"multiple":_vm.multiple,"filter":_vm.localFilter,"fetchElements":_vm.fetchCompanies,"label":"name","title":"Companies"},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []

export { render, staticRenderFns }